import client from '@js/client'
import resources from '@js/resources'
import { PAGE_SIZES } from '@js/constants'
import { snakeKeyToCamelKeyRecursive } from '@js/str-utils'

const getDefaultState = () => {
  return {
    tenantInvitationCodes: {
      data: [],
      count: 0,
      page: 1,
      pageSize: PAGE_SIZES.DEFAULT,
    },
    tenantUsers: {
      data: [],
      count: 0,
      page: 1,
      pageSize: PAGE_SIZES.DEFAULT,
    },
  };
};

const adminData = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    hasTenantInvitationCodes: state => {
      return state.tenantInvitationCodes.data.length > 0;
    },
    hasTenantUsers: state => {
      return state.tenantUsers.data.length > 0;
    },
    tenantInvitationCodesPageNum: state => {
      return parseInt(state.tenantInvitationCodes.count / state.tenantInvitationCodes.pageSize) + (state.tenantInvitationCodes.count % state.tenantInvitationCodes.pageSize > 0);
    },
    tenantUsersPageNum: state => {
      return parseInt(state.tenantUsers.count / state.tenantUsers.pageSize) + (state.tenantUsers.count % state.tenantUsers.pageSize > 0);
    },
  },
  mutations: {
    clearTenantInvitationCodes (state) {
      state.tenantInvitationCodes = {
        data: [],
        count: 0,
        page: 1,
        pageSize: PAGE_SIZES.DEFAULT,
      };
    },
    clearTenantUsers (state) {
      state.tenantUsers = {
        data: [],
        count: 0,
        page: 1,
        pageSize: PAGE_SIZES.DEFAULT,
      };
    },
    initialize (state) {
      Object.assign(state, getDefaultState());
    },
    setTenantInvitationCodes (state, { data, page, pageSize }) {
      state.tenantInvitationCodes.data = data.results.reduce((result, elem) => {
        result.push(snakeKeyToCamelKeyRecursive(elem));
        return result;
      }, []);
      state.tenantInvitationCodes.count = data.count;
      state.tenantInvitationCodes.page = page;
      state.tenantInvitationCodes.pageSize = pageSize;
    },
    setTenantUsers (state, { data, page, pageSize }) {
      state.tenantUsers.data = data.results.reduce((result, elem) => {
        result.push(snakeKeyToCamelKeyRecursive(elem));
        return result;
      }, []);
      state.tenantUsers.count = data.count;
      state.tenantUsers.page = page;
      state.tenantUsers.pageSize = pageSize;
    },
  },
  actions: {
    async fetchTenantInvitationCodes({ state, commit, rootGetters }, { search = '', page = 1, pageSize = PAGE_SIZES.DEFAULT }) {
      const domain = rootGetters['tenant/getTenantDomain'];
      const params = {
        params: {
          page: page,
          page_size: pageSize,
          ...(search.trim().length > 0 ? { search: search } : {}),
        },
      };
      const res = await client.get(
        resources['tenantInvitationCodes'](domain), params);
      await commit('setTenantInvitationCodes', { data: res.data, page: page, pageSize: pageSize});
      return res;
    },
    async fetchTenantUsers({ state, commit, rootGetters }, { search = '', page = 1, pageSize = PAGE_SIZES.DEFAULT }) {
      const domain = rootGetters['tenant/getTenantDomain'];
      const params = {
        params: {
          page: page,
          page_size: pageSize,
          ...(search.trim().length > 0 ? { search: search } : {}),
        },
      };
      const res = await client.get(
        resources['tenantUsers'](domain), params);
      await commit('setTenantUsers', { data: res.data, page: page, pageSize: pageSize});
      return res;
    },
  },
};

export default adminData;
